import React from "react";
import { useTranslation } from "react-i18next";
import { CalcProgressCard } from "../CalcProgressCard";
import { QueuePositionDialog } from "../QueuePositionDialog";
import { BlockingMessageDialog } from "../BlockingMessageDialog";

// v0.6.8 — extracted from CalculatePanel.jsx (LOC cap): every UI
// surface driven by the async calc job's state (inline progress card,
// the queue-position popup, and the blocked/failed-outcome popup),
// grouped so CalculatePanel only needs to pass `calcPoll` through
// once instead of rendering three siblings inline.
export const CalcJobSurfaces = ({ calcPoll }) => {
  const { t } = useTranslation();
  return (
  <>
    {calcPoll.job && (
      <div className="border-t border-slate-200 dark:border-slate-700 p-4">
        <CalcProgressCard job={calcPoll.job} onCancel={calcPoll.cancel} elapsedMs={calcPoll.elapsedMs} />
        <QueuePositionDialog job={calcPoll.job} onCancel={calcPoll.cancel} />
      </div>
    )}
    <BlockingMessageDialog
      open={!!calcPoll.blockingMessage} testid="calc-blocking-message"
      severity={calcPoll.blockingMessage?.severity} title={calcPoll.blockingMessage?.title}
      onOpenChange={(o) => !o && calcPoll.dismissBlockingMessage()}
    ><p>{calcPoll.blockingMessage?.body}</p></BlockingMessageDialog>
    {/* v0.6.10 — re-running replaces the current calc, and review
        acknowledgements belong to the calc they were made against, so
        a re-run strands them. This asks first. See useAsyncCalc's
        guardedStart for why it warns rather than carrying them
        forward. */}
    <BlockingMessageDialog
      open={!!calcPoll.pendingRerun} testid="calc-rerun-loses-review"
      severity="warning"
      title={t("ui.calculate.rerun_dialog.title", { defaultValue: "Re-running will restart the review queue" })}
      onOpenChange={(o) => !o && calcPoll.pendingRerun?.onCancel?.()}
      actions={[
        {
          label: t("ui.calculate.rerun_dialog.keep", { defaultValue: "Keep the current calculation" }),
          testid: "calc-rerun-cancel",
          onClick: () => calcPoll.pendingRerun?.onCancel?.(),
        },
        {
          label: t("ui.calculate.rerun_dialog.proceed", { defaultValue: "Re-run anyway" }),
          variant: "primary",
          testid: "calc-rerun-confirm",
          onClick: () => calcPoll.pendingRerun?.onProceed?.(),
        },
      ]}
    >
      <p>
        {t("ui.calculate.rerun_dialog.body_before", { defaultValue: "You have acknowledged" })}{" "}
        <strong>{calcPoll.pendingRerun?.ackedCount}</strong>{" "}
        {calcPoll.pendingRerun?.ackedCount === 1
          ? t("ui.calculate.rerun_dialog.body_after_one", {
            defaultValue: "row in the review queue. Re-running creates a NEW calculation, and those acknowledgements stay with the current one — the new queue starts from nothing and you would work through them again.",
          })
          : t("ui.calculate.rerun_dialog.body_after_other", {
            defaultValue: "rows in the review queue. Re-running creates a NEW calculation, and those acknowledgements stay with the current one — the new queue starts from nothing and you would work through them again.",
          })}
      </p>
      <p className="mt-2">
        {t("ui.calculate.rerun_dialog.not_deleted", {
          defaultValue: "They are not deleted. If you re-run and change your mind, the current calculation still has them.",
        })}
      </p>
    </BlockingMessageDialog>
  </>
  );
};

export default CalcJobSurfaces;
